import { cn } from '@/lib/cn'

/**
 * Renders the pre-formatted HTML the RPG Publisher API returns for entity
 * `name` / `stat-block` formats. The API is a trusted first-party source, but
 * we still scope styling under `.entity-html` (see index.css).
 *
 * NOTE: if untrusted player-generated entity HTML is ever served through this
 * path, sanitize server-side first (see _docs/05-contributions.md).
 */
export function EntityHtml({ html, className }: { html?: string; className?: string }) {
  if (!html) return null
  return <div className={cn('entity-html', className)} dangerouslySetInnerHTML={{ __html: html }} />
}
